import React from 'react'
import type { DivBlock as DivProps } from '@/payload-types'
import { RenderBlocks } from '@/blocks/RenderBlocks'

export const DivBlock: React.FC<DivProps> = ({ layout, className }) => {
  return (
    <div className={className || undefined}>
      <RenderBlocks blocks={layout ?? []} />
    </div>
  )
}
